import React from "react";
import { colors } from "../../../utils/theme";
import styled from "styled-components";
import Calendar from "./Calendar";
import Popup from "./Popup";

import { TablaTime } from "./TablaTime";

const Container = styled.div`
  .paginator {
    display: flex;
    padding: 1rem;
    background-color: ${colors.gris};
    margin-bottom: 2rem;
    justify-content: center;
  }

  .title {
    color: ${colors.primary};
    font-size: 1.5rem;
    font-weight: bold;
  }
`;

const ContainerSchedule = styled.div`
  display: flex;
  gap: 20px;
  @media (max-width: 1024px) {
    flex-direction: column;
    align-items: center;
    
  }
`;

const Calendario = styled.div`
  width: 50%;
  align-items: center;
  justify-content: center;
  
  @media (max-width: 1024px) {
    width: 80%;
  }
  @media (max-width: 550px) {
    width: 95%;
  }
`;

const Table = styled.div`
  width: 50%;
  align-items: center;

  @media (max-width: 768px) {
    justify-content: center;
    width: 70%;
  }
  @media (max-width: 600px) {
    width: 100%;
  }
  tr {
    font-size: 1.5rem;
    border: 1px solid ${colors.gris};
    text-align: center;
    color: ${colors.fifth};
    font-weight: bold;
  }

  th {
    padding: 1rem;
    color: ${colors.blanco};
  }

  td {
    padding: 1rem;
  }

  thead {
    background-color: ${colors.azul};
  }

  tbody {
    background-color: ${colors.blanco};
  }
`;

export const AvailabilityComponent = () => {
  return (
    <Container>
      {/* titulo de la sesion */}
      <div className="paginator">
        <span className="title">DISPONIBILIDAD DE CITA</span>
      </div>
      <ContainerSchedule>
        {/* calendario */}
        <Calendario>
          <Calendar />
        </Calendario>
        {/* tabla de los horarios */}
        <Table>
          <TablaTime newPatient={true} />
        </Table>
      </ContainerSchedule>
      {/* Componente del boton que abre el modal */}
      <Popup />
    </Container>
  );
};
